import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(marketing)/training/error.tsx");
